import {
  Alert,
  Box,
  InputAdornment,
  Pagination,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Search, Close } from "@material-ui/icons";
import { useGetSaleFactorsList } from "../../../hooks/out-warehouse-with-factor/useGetSaleFactorsList";
import LoadingSpinner from "../../global/loading-spinner";
import SaleFactorsNested from "./sale-factors-nested";

const useStyles = makeStyles((theme) => ({
  searchBox: {
    backgroundColor: "#2530B8",
    padding: "20px 32px",
    borderRadius: "0 0 50px 50px",
    [theme.breakpoints.down("360")]: {
      padding: "20px 14px",
    },
    "& .Mui-focused .MuiInputAdornment-root": {
      opacity: 1,
    },
  },
  buyFactorList: {
    padding: "20px 32px",
    [theme.breakpoints.down("360")]: {
      padding: "20px 14px",
    },
  },
  clear: {
    opacity: 0,
    cursor: "pointer",
  },
}));

const SaleFactorsList = () => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useGetSaleFactorsList(page);
  const Array = data?.result?.items;
  console.log(data);
  const [searchTerm, setSearchTerm] = useState();
  const [input, setInput] = useState("");

  const handleSetPage = () => {
    setPage(page + 1);
  };

  const handleChange = (e) => {
    const searchTerm = Array.filter((row) =>
      row.id.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setSearchTerm(searchTerm);
    setInput(e.target.value);
  };

  const handleClear = () => {
    setInput("");
    setSearchTerm(undefined)
  };

  return (
    <>
      <Box className="page-title">خروج کالا از انبار با فاکتور</Box>
      <Box className={classes.searchBox}>
        <TextField
          name="search"
          autoComplete="true"
          placeholder="جستجوی فاکتور (بر اساس شماره فاکتور)"
          fullWidth
          onChange={handleChange}
          value={input}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="start"
                className={classes.clear}
                onClick={handleClear}
              >
                <Close fontSize={"small"} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box className={classes.buyFactorList}>
          {searchTerm?.length === 0 ? (
            <Box mb={3}>
              <Alert severity="error">فاکتوری با این کد یافت نشد.</Alert>
            </Box>
          ) : (
            searchTerm?.map(({ ...otherProps }, index) => (
              <SaleFactorsNested key={index} {...otherProps} />
            ))
          )}
          {searchTerm === undefined &&
            Array?.map(({ ...otherProps }, index) => (
              <SaleFactorsNested key={index} {...otherProps} />
            ))}
        </Box>
      )}
      {data?.result.totalPage > 1 && (
        <Pagination
          page={data?.result.currentPage}
          variant="outlined"
          shape="rounded"
          size="small"
          onChange={handleSetPage}
        />
      )}
    </>
  );
};
export default SaleFactorsList;
